import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AdminDomainsState } from './admin-domains.reducer';

export const selectAdminDomainsState =
  createFeatureSelector<AdminDomainsState>('adminDomains');

export const selectAdminDomains = createSelector(
  selectAdminDomainsState,
  (state) => state.domains,
);

export const selectAdminDomainsMeta = createSelector(
  selectAdminDomainsState,
  (state) => state.meta,
);

export const selectAdminDomainsLoading = createSelector(
  selectAdminDomainsState,
  (state) => state.isLoading,
);

export const selectSelectedAdminDomain = createSelector(
  selectAdminDomainsState,
  (state) => state.selectedDomain,
);

export const selectAdminDomainDetailLoading = createSelector(
  selectAdminDomainsState,
  (state) => state.isDetailLoading,
);

export const selectAdminDomainsSubmitting = createSelector(
  selectAdminDomainsState,
  (state) => state.isSubmitting,
);

export const selectAdminDomainsError = createSelector(
  selectAdminDomainsState,
  (state) => state.error,
);

export const selectAdminDomainsLastQuery = createSelector(
  selectAdminDomainsState,
  (state) => state.lastQuery,
);
